<template>
    <v-container fluid class="py-6">
        <h1 class="mb-4">Dashboard de Produção de Placas</h1>
        <v-row>
            <v-col cols="12" md="3">
                <v-card class="pa-4" outlined>
                    <div class="d-flex align-center justify-space-between">
                        <div>
                            <div class="headline">Hoje</div>
                            <div class="caption">Total produzidas</div>
                        </div>
                        <v-icon color="primary">assessment</v-icon>
                    </div>
                    <div class="display-1 font-weight-bold mt-2">{{ stats.today.total }}</div>
                </v-card>
            </v-col>

            <v-col cols="12" md="3">
                <v-card class="pa-4" outlined>
                    <div class="d-flex align-center justify-space-between">
                        <div>
                            <div class="headline">Aprovadas (Hoje)</div>
                            <div class="caption">Qualidade OK</div>
                        </div>
                        <v-icon color="success">check_circle</v-icon>
                    </div>
                    <div class="display-1 font-weight-bold mt-2 text--success">{{ stats.today.approved }}</div>
                </v-card>
            </v-col>

            <v-col cols="12" md="3">
                <v-card class="pa-4" outlined>
                    <div class="d-flex align-center justify-space-between">
                        <div>
                            <div class="headline">Reprovadas (Hoje)</div>
                            <div class="caption">Necessita retrabalho</div>
                        </div>
                        <v-icon color="error">highlight_off</v-icon>
                    </div>
                    <div class="display-1 font-weight-bold mt-2 text--error">{{ stats.today.rejected }}</div>
                </v-card>
            </v-col>

            <v-col cols="12" md="3">
                <v-card class="pa-4" outlined>
                    <div class="d-flex align-center justify-space-between">
                        <div>
                            <div class="headline">Taxa de Aprovação</div>
                            <div class="caption">Hoje</div>
                        </div>
                        <v-icon color="info">show_chart</v-icon>
                    </div>
                    <div class="display-1 font-weight-bold mt-2">{{ approvalRateToday }}%</div>
                </v-card>
            </v-col>
        </v-row>

        <v-card class="pa-4 mt-6" outlined>
            <div class="d-flex align-center justify-space-between mb-2">
                <div>
                    <div class="headline">Últimos 7 dias</div>
                    <div class="caption">Total, aprovadas e reprovadas por dia</div>
                </div>
                <v-btn icon @click="load()"><v-icon>refresh</v-icon></v-btn>
            </div>
            <v-row>
                <v-col cols="12" md="8">
                    <v-sparkline
                        :value="sparkTotals"
                        :labels="sparkLabels"
                        color="primary"
                        line-width="2"
                        auto-draw
                        auto-draw-duration="1200"
                        label-size="10"
                    ></v-sparkline>
                </v-col>
                <v-col cols="12" md="4">
                    <v-list dense>
                        <v-list-item v-for="d in stats.last7days" :key="d.date">
                            <v-list-item-content>
                                <v-list-item-title class="d-flex align-center justify-space-between">
                                    <span>{{ formatDate(d.date) }}</span>
                                    <span class="font-weight-bold">{{ d.total }}</span>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    <span class="success--text">Aprovadas: {{ d.approved }}</span>
                                    <span class="ml-3 error--text">Reprovadas: {{ d.rejected }}</span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'DailyDashboard',
    data() {
        return {
            stats: {
                today: { total: 0, approved: 0, rejected: 0 },
                last7days: [],
            },
        };
    },
    computed: {
        approvalRateToday() {
            const t = this.stats.today.total || 0;
            const a = this.stats.today.approved || 0;
            if (!t) return 0;
            return Math.round((a / t) * 100);
        },
        sparkTotals() {
            return this.stats.last7days.map(d => d.total);
        },
        sparkLabels() {
            return this.stats.last7days.map(d => this.formatDate(d.date));
        },
    },
    methods: {
        async load() {
            // try {
            //     const res = await this.$http.get('/stats/boards');
            //     this.stats = res || this.stats;
            // } catch (e) {
            //     this.$eventHub.$emit('msgError', e.message || 'Erro ao carregar estatísticas.');
            // }
        },
        formatDate(iso) {
            return this.$moment(iso).format('DD/MM');
        },
    },
    mounted() {
        this.load();
    },
};
</script>

<style scoped>
.display-1 {
    font-size: 2rem;
}
.headline { font-weight: 600; }
.caption { color: #64748b; }
</style>
